/**
 * Shell layout — bare pass-through for the web (host) micro-frontend.
 *
 * The web shell owns authentication flows (login, verify) and user account
 * management (profile, settings). Individual pages render their own chrome
 * (hero sections, headers, footers). This layout intentionally provides
 * **no** persistent UI — it simply renders child routes via `<Outlet>`.
 *
 * @module components/layout
 */

import { Outlet } from 'react-router';

// ---------------------------------------------------------------------------
// Layout
// ---------------------------------------------------------------------------

export function Layout() {
	return <Outlet />;
}
